export { NAVS_REP, MAP_ALL_ATTRS_REP }
const MAP_ATTRS_REP = {
	id:'ATTRS_REP',
	navLabel:'sidenav.repmodel.label',
	navIcon:'file',
	instancesClass:{
		repmodel:{
			iconClass: 'file',
			attrsList: [
				{attrName: 'name', attrCol: '10%', searchable: true, sortable: true},
				{attrName: 'description', attrCol: '15%', searchable: true, sortable: true},
				{attrName: 'title', attrCol: '20%', searchable: true, sortable: true}
				// {attrName: 'jrxmlFile', attrCol: '30%', searchable: true, sortable: true}
			]
		}
	}
}
const NAVS_REP = [MAP_ATTRS_REP]

const MAP_ALL_ATTRS_REP = {};
for (let key in MAP_ATTRS_REP.instancesClass) {
	MAP_ALL_ATTRS_REP[key]= MAP_ATTRS_REP.instancesClass[key]
}